import { useOutletContext } from "react-router-dom";

import ArtifactFilesView from "../../views/ArtifactFilesView/ArtifactFilesView";

export default function ArtifactFiles() {
	const context = useOutletContext();

	return <ArtifactFilesView {...context} />;
}
